import { RegisterExamUpload } from "@/components/cockpit/register-exam-upload";

export function ExamUpload({ patientId }: { patientId: number }) {
	return (
		<div className="flex justify-end">
			<RegisterExamUpload patientId={patientId} />
		</div>
	);
}
